import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	Modal,
} from '../../components';
import React from 'react';
import { Formik } from 'formik';

const CreateSubwallet = ({ closeModal, onSubmit, validationSchema, loading }) => {

	return (
		<Modal closeModal={closeModal}>
			<Formik
				initialValues={{
					name: '',
					limit: 0,
					limitPeriod: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Name of Petty Cash"
							placeholder="e.g Petty Cash 1"
							name="name"
							mb={2}
							value={values.name}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.name}
							touched={touched.name}
						/>

						<MimaInput
							type="text"
							labelTitle="Limit"
							placeholder=""
							name="limit"
							mb={2}
							value={values.limit}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.limit}
							touched={touched.limit}
						/>

						<MimaDropdown
							labelTitle="Period"
							placeholder="Select"
							name="limitPeriod"
							value={values.limitPeriod}
							id="customerGroup"
							onChange={data => {
								setFieldValue('limitPeriod', data.key);
							}}
							data={[{
								key: 'DAILY',
								value: 'DAILY'
							},{
								key: 'WEEKLY',
								value: 'WEEKLY'
							},{
								key: 'MONTHLY',
								value: 'MONTHLY'
							},{
								key: 'YEARLY',
								value: 'YEARLY'
							}]}
							touched={touched.limitPeriod}
							error={errors.limitPeriod}
						/>

						<MimaButton
							title="Save"
							loading={loading}
							type="submit"
							onClick={handleSubmit}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default CreateSubwallet;
